import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces'
import type {
  IAuditoriaFinancieraBusqueda,
  IAuditoriaFinancieraItem,
  IAuditoriaFinancieraTrazabilidad,
  IAuditoriaFinancieraValorPortafolioPreview,
  IAuditoriaFinancieraValoresForm,
  IAuditoriaFinancieraValoresResultado
} from '@/modules/Financiera/interfaces'
import type { AxiosResponse } from 'axios'

export class AuditoriaFinancieraService extends BaseService<IAuditoriaFinancieraItem> {
  constructor() {
    super({ baseUrl: 'financiera/auditoria/' })
  }

  async search(
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IAuditoriaFinancieraBusqueda>>> {
    return this.http
      .get<IResponseApi<IAuditoriaFinancieraBusqueda>>('/search', { params })
      .catch(this.errorHandle)
  }

  async actualizarValores(
    cittId: number,
    body: IAuditoriaFinancieraValoresForm
  ): Promise<AxiosResponse<IResponseApi<IAuditoriaFinancieraValoresResultado>>> {
    return this.http
      .put<IResponseApi<IAuditoriaFinancieraValoresResultado>>(`/valores/${cittId}`, body)
      .catch(this.errorHandle)
  }

  async previsualizarValorPortafolio(
    cittId: number
  ): Promise<AxiosResponse<IResponseApi<IAuditoriaFinancieraValorPortafolioPreview>>> {
    return this.http
      .get<IResponseApi<IAuditoriaFinancieraValorPortafolioPreview>>(`/valores/${cittId}/portafolio`)
      .catch(this.errorHandle)
  }

  async trazabilidad(
    ciadId: number
  ): Promise<AxiosResponse<IResponseApi<IAuditoriaFinancieraTrazabilidad[]>>> {
    return this.http
      .get<IResponseApi<IAuditoriaFinancieraTrazabilidad[]>>(`/trazabilidad/${ciadId}`)
      .catch(this.errorHandle)
  }
}
